import './styles/welcome.css';
import React, { useEffect, useState } from 'react';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

import Button from 'react-bootstrap/Button';
import Offcanvas from 'react-bootstrap/Offcanvas';

import RoomList from './RoomList.js';
import './styles/App.css';
import './styles/menu.css';
function Menu (props)
{
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
    return(
      <div id="select_menu">
        <Button id="menu-btn" variant="primary" onClick={handleShow} className="me-2">menu</Button>
        <Offcanvas show={show} onHide={handleClose} scroll="true">
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>Chat Rooms</Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            {props.members.map((room) => {
              return <RoomList room_id={room.id} handle_room_select={props.handle_room_select} room_name={room.name}/>
            })}
          </Offcanvas.Body>
        </Offcanvas>
      { 
        props.members.map((room) => {
          return <RoomList room_id={room.id} handle_room_select={props.handle_room_select} room_name={room.name}/>
        })
      }
      </div>
    );
}
export default Menu;
